<template>
    <div class="summary-footer conainer-fluid">
        <div class="row h-100 mx-0 justify-content-center align-items-center">
            <div class="col-7 col-8-5 col-md-4 col-lg-3 offset-md-1 offset-2 offset-0-5 footer-text">
                Jeśli masz do nas pytania
                <br>
                - zapraszamy Cię do kontaktu
                <a :href="`mailto: ${systemConst.SUMMARY_FOOTER_EMAIL}`" :title="systemConst.SUMMARY_FOOTER_EMAIL">
                    <img class="footer-mail-icon mr-2" :src="require(`../../assets/images/${systemConst.EMAIL_ICON_NAME}`)" title="email-icon" alt="email-icon">
                    <span class="my-2 font-weight-bold">{{ systemConst.SUMMARY_FOOTER_EMAIL }}</span>
                </a>
            </div>
            <div class="col-7 col-8-5 col-md-4 col-lg-3 offset-md-0 offset-2 offset-0-5 footer-text">
                <a class="link-back" :href="pageUrl">Przejdź do strony głównej ></a>
            </div>
        </div>
    </div>
</template>

<script>
import systemConst from '@SYSTEM_CONSTANTS'

export default {
    name: 'SummaryFooter',
    data () {
        return {
            systemConst,
            pageUrl: process.env.VUE_APP_PAGE_URL
        }
    }
}
</script>
